module.exports = __webpack_public_path__ + "static/media/icn_b2_m.be317ff3.svg";